(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('shadowItCounts', ["path", "securityEventsDao", "odometerFormat", "securityEventsLinkGenerator", function (path, securityEventsDao, odometerFormat, securityEventsLinkGenerator) {
        function formatNumber(n) {
            try {
                return n.toLocaleString('en-US');
            } catch (e) {
                return '' + n;
            }
        }
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('shadow-it/counts').template('counts'),
            scope: {
                saasList: '=',
                resolution: '='
            },
            link: function ($scope) {
                $scope.widgetApi = {};
                $scope.loading = true;
                $scope.pendingClass = {};
                $scope.pendingTip = {
                    content: {},
                    position: {
                        at: 'bottom center',
                        my: 'top center'
                    }
                };
                $scope.totalTip = {
                    content: {},
                    position: {
                        at: 'bottom center',
                        my: 'top center'
                    }
                };
                $scope.loadData = function () {
                    $scope.totalHref = securityEventsLinkGenerator.createHref({
                        saas: _($scope.saasList).pluck('name'),
                        resolution: $scope.resolution,
                        current_state: [
                            'new',
                            'remediated'
                        ],
                        type: 'shadow_it'
                    });
                    $scope.pendingHref = securityEventsLinkGenerator.createHref({
                        saas: _($scope.saasList).pluck('name'),
                        resolution: $scope.resolution,
                        current_state: ['new'],
                        type: 'shadow_it'
                    });
                    return securityEventsDao.list().params({
                        groupBy: 'current_state',
                        filterEnum_saas: _($scope.saasList).map(function (saas) {
                            return saas.name;
                        }).join(','),
                        filterEnum_current_state: 'new,remediated',
                        filterEnum_type: 'shadow_it',
                        afterColumn: 'create_time',
                        afterStep: $scope.resolution,
                        afterFromNow: true,
                        afterMax: 1
                    }).then(function (response) {
                        $scope.total = 0;
                        $scope.pending = 0;
                        _(response.data.rows).each(function (row) {
                            $scope.total += row.count || 0;
                            if (row.current_state === 'new') {
                                $scope.pending += row.count || 0;
                            }
                        });
                        $scope.totalF = odometerFormat($scope.total);
                        $scope.pendingF = odometerFormat($scope.pending);
                        if ($scope.pending > 0) {
                            $scope.pendingClass = { 'status-bad': true };
                        } else {
                            $scope.pendingClass = { 'status-good': true };
                        }
                        if ($scope.pending === 0) {
                            $scope.pendingTip.content.text = 'All events approved';
                            $scope.totalTip.content.text = 'All events approved';
                        } else {
                            $scope.pendingTip.content.text = formatNumber($scope.pending) + ' events require your attention';
                            if ($scope.pending === $scope.total) {
                                $scope.totalTip.content.text = formatNumber($scope.pending) + ' events require your attention';
                            } else {
                                $scope.totalTip.content.text = formatNumber($scope.total - $scope.pending) + ' out of ' + formatNumber($scope.total) + ' (' + ($scope.total ? Math.floor(100 * ($scope.total - $scope.pending) / $scope.total) : 0) + '%) approved';
                            }
                        }
                        $scope.loading = false;
                    });
                };
                $scope.$watchGroup([
                    'resolution',
                    'saasList'
                ], function () {
                    $scope.widgetApi.reload();
                });
            }
        };
    }]);
}());